import { ArrayHelper } from '@controladad/ng-base';
import { NameEntity } from '@models';

export function extractName<T extends { englishName: string; arabicName: string }>(obj: T): NameEntity {
  return { arabic: obj.arabicName, english: obj.englishName };
}

export function toFixedFn(digits: number): (value: string | number) => string {
  return (value) => Number(value).toFixed(digits);
}

export function joinNamesFn(separator = ' - ') {
  return (input: string[] | Record<string, string> | { english: string; arabic: string }): string => {
    const items = Array.isArray(input) ? input : Object.values(input);

    return ArrayHelper.dedupe(items)
      .filter((v) => !!v)
      .join(separator);
  };
}

export function dashJoin(input: string[] | Record<string, string>): string {
  const items = Array.isArray(input) ? input : Object.values(input);

  return ArrayHelper.dedupe(items)
    .filter((v) => !!v)
    .join(' - ');
}

export function joinArrayWithNullFn(separator = '\n ') {
  return (input: (string | number | null)[] | undefined): string => {
    if (!input || !Array.isArray(input)) return '-';
    if (input.length === 0) return '-';
    return input
      .map(v => v === null || v === undefined || v === '' ? '-' : String(v))
      .join(separator);
  };
}
